import PageHero from "../components/PageHero";
import CTASection from "../components/CTASection";
import { IMAGES } from "../data/content";

const VALUES = [
  { title: "Dignity", text: "Every person deserves to be treated with respect, whatever their paperwork says." },
  { title: "Accuracy", text: "Details matter in immigration. We prepare carefully and check twice." },
  { title: "Access", text: "Qualified help should be understandable, reachable, and fairly priced." },
  { title: "Guidance", text: "We explain what is happening, what is needed, and what comes next — in plain language." },
  { title: "Accountability", text: "We tell clients clearly what we can do, what we cannot do, and who can." },
  { title: "Integration", text: "Paperwork is only part of belonging. We support the whole journey." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero
        eyebrow="About CF Full Circle"
        title="Built around the whole journey"
        lead="Most immigration services focus on one filing or one legal problem. But the person behind that filing may also need a birth certificate from another country, an ITIN, a driver's license, a bank account, health insurance, school enrollment for a child, employment assistance, transportation, or help understanding an unfamiliar system."
        image={IMAGES.counseling}
        alt="The CF Full Circle team welcoming a client"
      />

      <section className="py-16 lg:py-20" data-testid="about-why">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-xl sm:text-2xl font-serif text-navy leading-relaxed text-balance">
            CF Full Circle was created around the whole journey. We organize immigration and integration needs into one clear roadmap so clients understand what needs to happen, who is responsible, and what comes next.
          </p>
        </div>
      </section>

      <section className="py-16 lg:py-24 bg-sand/60" data-testid="mission-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div className="bg-surface border border-line rounded-2xl p-8 lg:p-10 shadow-sm">
            <p className="text-xs font-sans font-bold tracking-[0.15em] uppercase text-teal mb-4">Mission</p>
            <p className="text-base text-ink leading-relaxed">
              CF Full Circle exists to help immigrants and their families navigate both the legal immigration process and the practical work of building a stable life in the United States. We combine authorized immigration legal services, document and identity support, tax and financial-start assistance, screening and verification, and newcomer navigation so clients can move from uncertainty to stability with a trusted guide beside them.
            </p>
          </div>
          <div className="bg-[#101315] border border-white/10 rounded-2xl p-8 lg:p-10 shadow-sm">
            <p className="text-xs font-sans font-bold tracking-[0.15em] uppercase text-champagne mb-4">Vision</p>
            <p className="text-base text-cream/90 leading-relaxed">
              To become a trusted national model for immigrant legal access and integration — a place where newcomers can obtain qualified representation, essential documents, practical settlement support, and a clear pathway toward permanent belonging.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-24" data-testid="values-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl font-serif font-semibold text-navy tracking-tight mb-10">Our values</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {VALUES.map((v) => (
              <div key={v.title} className="bg-surface border border-line rounded-xl p-6 shadow-sm" data-testid={`value-${v.title.toLowerCase()}`}>
                <h3 className="text-lg font-serif font-semibold text-navy">{v.title}</h3>
                <p className="mt-2 text-sm text-mutedink leading-relaxed">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection title="Meet the team that walks beside you." primaryLabel="Start Your Journey" />
    </div>
  );
}
